export function shouldRequireRealName(card: Record<string, unknown> | null | undefined) {
  return String(card?.authNeed ?? '') === '0' && String(card?.realNameStatus ?? '') !== '2'
}

export function getRealNameAction(authWay: unknown, url: unknown) {
  if (typeof url !== 'string' || !url.trim()) return 'none'
  const way = Number(authWay)
  return way === 1 || way === 5 ? 'qr' : 'redirect'
}

export async function copyTextToClipboard(text: string) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (_) {}
  }

  const input = document.createElement('textarea')
  input.value = text
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.select()
  const copied = document.execCommand('copy')
  document.body.removeChild(input)
  return copied
}

export function shouldPromptRealName(
  card: Record<string, unknown> | null | undefined,
  orders: Array<Record<string, unknown>> | null | undefined
) {
  return shouldRequireRealName(card) &&
    Array.isArray(orders) &&
    orders.some(order => String(order?.useStatus ?? '') === '使用中')
}
